export function excelTollReportColumns() {
  const tYear = { key: 'tYear', header: 'År', width: 10 }
  const tMonth = { key: 'tMonth', header: 'Måned', width: 10 }
  const consolidatedInvoiceAgreement = { key: 'consolidatedInvoiceAgreement', header: 'Samlefaktura', width: 15 }
  const amountIncVAT = { key: 'amountIncVAT', header: 'Beløp inkl. MVA', width: 15 }
  const antallPasseringer = { key: 'antallPasseringer', header: 'Antall passeringer', width: 20 }

  return [tYear, tMonth, consolidatedInvoiceAgreement, amountIncVAT, antallPasseringer]
}

export function excelTollReportDetailsColumns() {
  const regNo = { key: 'regNo', header: 'Regnr', width: 15 }
  const vehicleID = { key: 'vehicleID', header: 'Kjøretøy ID', width: 15 }
  const invoiceGroupingDescription = { key: 'invoiceGroupingDescription', header: 'Fakturagruppe', width: 25 }
  const carDescription = { key: 'carDescription', header: 'Objekt', width: 25 }
  const driverName = { key: 'driverName', header: 'Sjåfør', width: 20 }
  const amountIncVAT = { key: 'amountIncVAT', header: 'Beløp inkl. MVA', width: 15 }
  const antallPasseringer = { key: 'antallPasseringer', header: 'Antall passeringer', width: 20 }

  return [regNo, vehicleID, invoiceGroupingDescription, carDescription, driverName, amountIncVAT, antallPasseringer]
}

export function excelTollReportAccountDetailsColumns() {
  const transactionDate = { key: 'transactionDate', header: 'Dato', width: 10 }
  const transactionTime = { key: 'transactionTime', header: 'Tidspunkt', width: 10 }
  const regNo = { key: 'regNo', header: 'Regnr', width: 15 }
  const referenceNo = { key: 'referenceNo', header: 'Brikke-ID', width: 20 }
  const tollStation = { key: 'tollStation', header: 'Sted', width: 25 }
  const field = { key: 'field', header: 'Felt', width: 15 }
  const amount = { key: 'amount', header: 'Beløp', width: 15 }

  return [transactionDate, transactionTime, regNo, referenceNo, tollStation, field, amount]
}
